import { useState, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
// components
import LoadingScreen from "../components/loading-screen";
//
import { useAuthContext } from "./useAuthContext";
import { PATH_AUTH } from "../routes/paths";

// ----------------------------------------------------------------------

type SalesUserGuardProps = {
  children: ReactNode;
};

export default function SalesUserGuard({ children }: SalesUserGuardProps) {
  const { user, isSalesUser, isAuthenticated, isInitialized } =
    useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (!isSalesUser) {
    return <Navigate to={"/404"} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children}</>;
}
